import React, { useContext } from "react";
import { MediaTypeIcon } from "./mediaTypeIcon";
import { CDNContext } from '../../../../constants/cdnContext';
var baseWrapper = function (val, article) {
    return React.createElement("a", { href: article.link, target: "_blank" }, val);
};
var buildImgSrc = function (url, cdnRoot, disableCDN) {
    if (cdnRoot === void 0) { cdnRoot = ''; }
    if (disableCDN)
        return url;
    var formattedCDNRoot = cdnRoot.replace(/\/$/, '');
    return "".concat(formattedCDNRoot, "/cdn-cgi/image/width=640,height=640,fit=contain/").concat(url);
};
export function ImageWrapper(props) {
    var article = props.article, dataTestId = props.dataTestId, _a = props.wrapperFunc, wrapperFunc = _a === void 0 ? baseWrapper : _a;
    var fullSizeImageUrl = article.fullSizeImageUrl, altText = article.altText, mediaType = article.mediaType;
    var _b = useContext(CDNContext), disableCDN = _b.disableCDN, rootUrl = _b.rootUrl;
    var imgSrc = buildImgSrc(fullSizeImageUrl, rootUrl, disableCDN);
    return (React.createElement(React.Fragment, null, wrapperFunc(React.createElement(React.Fragment, null,
        mediaType && React.createElement(MediaTypeIcon, { mediaType: mediaType }),
        React.createElement("img", { srcSet: imgSrc, style: { objectFit: "cover" }, width: "100%", height: "100%", loading: "lazy", alt: altText, "data-testid": dataTestId })), article)));
}
